import EditBase from "../EditBase"

class EditTriangle extends EditBase {

    constructor(options) {
        super(options);
    }

    initProperty() {
        var $this = this;
        var hierarchyProperty = new $this.Cesium.CallbackProperty(function () {
            return new $this.Cesium.PolygonHierarchy($this.plot.attrPlot["edit_positions"]);
        }, false);
        this.plot.polygon.hierarchy = hierarchyProperty;
    }
}

export default EditTriangle;